import React, { useState } from 'react';
import { Stack, PrimaryButton, Text } from '@fluentui/react';
import { localStorageAvailable } from '../utils/localStorage';
import { getDisplayNameFromLocalStorage, saveDisplayNameToLocalStorage, getDisplayMailFromLocalStorage, saveDisplayMailToLocalStorage } from '../utils/localStorage';
import { Field } from './field';
import { TeamsMeetingLinkLocator } from '@azure/communication-calling';
import { withTranslation, WithTranslation } from "react-i18next";

export interface HomeScreenProps extends WithTranslation {
    startCallHandler(callDetails: {
        displayName: string;
        displayMail: string;
        teamsLink?: TeamsMeetingLinkLocator;
    }): void;
    joiningExistingCall: boolean;
    meetingUrl: string
}

const HomeScreen = (props: HomeScreenProps): JSX.Element => {
    const { startCallHandler } = props;
    const localize = props.t;
    const buttonText = localize("AcsIniciarAtendimento");

    // Get display name and email from local storage if available
    const defaultDisplayName = localStorageAvailable ? getDisplayNameFromLocalStorage() : null;
    const defaultDisplayMail = localStorageAvailable ? getDisplayMailFromLocalStorage() : null;

    const [displayName, setDisplayName] = useState<string | undefined>(defaultDisplayName ?? undefined);
    const [displayMail, setDisplayMail] = useState<string | undefined>(defaultDisplayMail ?? undefined);
    const teamsLink = { meetingLink: props.meetingUrl }

    const buttonEnabled = displayName && displayMail;

    return (
        <Stack
            wrap
            className="home-screen adjust"
        >
            <Field
                defaultName={displayName}
                setName={setDisplayName}
                label={localize("AcsNome")}
                id={`name`}
                placeholder={localize("AcsNomeInfo")}
                errorMsg={localize("AcsNomeObrigatorio")}
                errorMsgChars={localize("AcsNomeLimite")}
                required
            />

            <Field
                defaultName={displayMail}
                setName={setDisplayMail}
                label={localize("AcsEmail")}
                id={`mail`}
                placeholder={localize("AcsEmailInfo")}
                errorMsg={localize("AcsEmailObrigatorio")}
                errorMsgChars={localize("AcsEmailLimite")}
                required
            />

            <PrimaryButton
                disabled={!buttonEnabled}
                text={buttonText}
                onClick={() => {
                    if (displayName && displayMail) {
                        saveDisplayNameToLocalStorage(displayName);
                        saveDisplayMailToLocalStorage(displayMail);
                        startCallHandler({
                            displayName,
                            displayMail,
                            teamsLink,
                        });
                    }
                }}
            />
        </Stack>
    );
};

const homeScreenWithTranslation = withTranslation()(HomeScreen);
export default homeScreenWithTranslation;